import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { NGXLogger } from 'ngx-logger';

interface Blog {
  title: string;
  link: string;
  pubDate: string;
  description: string;
  imageUrl: string;
}

@Component({
  selector: 'tea-shop-fe-blog-list',
  standalone: false,
  templateUrl: './blog-list.component.html'
})
export class BlogListComponent {
  blogs$: Observable<Blog[]>;
  private static API_HOST = environment.apiHost || '';

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
  ) {
    this.blogs$ = this.fetchBlogs();
  }

  private fetchBlogs(): Observable<Blog[]> {
    const rssFeed = `${BlogListComponent.API_HOST}/api/blog`;
    this.logger.log('Fetching blog posts from', rssFeed);
    // const rssFeed = 'https://blog.sencha-tea.com/rss/';
    
    return this.http.get(rssFeed, { responseType: 'text' }).pipe(
        map(response => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(response, 'text/xml');
        const items = xml.querySelectorAll('item');
        this.logger.log(`Fetched ${items.length} blog posts`, items);
        return Array.from(items).map(item => ({
          title: item.querySelector('title')?.textContent ?? '',
          link: item.querySelector('link')?.textContent ?? '',
          pubDate: item.querySelector('pubDate')?.textContent ?? '',
          description: item.querySelector('description')?.textContent ?? '',
          imageUrl: item.querySelector('media\\:content, content')?.getAttribute('url') || 
                   item.querySelector('enclosure')?.getAttribute('url') ||
                   this.extractImageFromDescription(item.querySelector('description')?.textContent || ''),
        })).slice(0, 3); // Get first 3 blog posts
      })
    );
  }

  private extractImageFromDescription(description: string): string {
    const div = document.createElement('div');
    div.innerHTML = description;
    const img = div.querySelector('img');
    return img?.src || '';
  }
}
